<template>
  <div class="flex flex-col">
    <input type="hidden" name="template" :value="template ? template.uuid : null" />
    <input type="hidden" name="contact" :value="contact ? contact.id : null" />

    <label class="mb-2">
      {{ $t('documents.template') }}
    </label>

    <options
      :values="templates"
      :empty="$t('documents.no_template')"
      identifier="uuid"
      v-model="template"
    >
      <template #option="{ option }">
        <div class="flex max-w-48 flex-col items-stretch py-1 leading-snug">
          <span class="font-medium">{{ option.name }}</span>
          <span class="text-sm" v-if="option.owner_name">{{ option.owner_name }}</span>
        </div>
      </template>
    </options>

    <p class="mt-1 text-sm text-gray-700" v-if="template && template.description">
      {{ template.description }}
    </p>

    <p
      class="mt-1 text-sm text-gray-500"
      v-else-if="!template && createTemplatePath"
      v-html="$t('documents.create_template', { here: hereLink(createTemplatePath) })"
    ></p>

    <input type="hidden" name="owner" />
    <label class="mt-4 flex flex-col" v-if="template === false && ownerOptions">
      <span class="mb-2"> Van<span class="text-brand-500">*</span> </span>
      <select name="owner" class="form-input" v-model="owner">
        <option value="" v-if="!hasOneOwnerOption">{{ $t('documents.select_owner') }}</option>
        <optgroup v-for="(options, name) in ownerOptions" :key="name" :label="name">
          <option v-for="(name, id) in options" :key="id" :value="id" v-text="name" />
        </optgroup>
      </select>
    </label>

    <template v-if="contacts.length > 0">
      <label class="mb-2 mt-4">
        {{ $t('documents.contact') }}
      </label>
      <options :values="contacts" :empty="$t('documents.no_contact')" v-model="contact">
        <template #option="{ option }">
          <div class="flex max-w-48 flex-col items-stretch py-1 leading-snug">
            <span class="font-medium">{{ option.name }}</span>
            <span class="text-sm">{{ option.role }}</span>
          </div>
        </template>
      </options>
    </template>

    <div class="mt-6 flex flex-wrap items-center" v-if="showFooter">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      template: null,
      owner: '',
      contact: false,
    }
  },
  props: {
    createTemplatePath: { type: String },
    templates: { type: Array },
    contacts: { type: Array },
    ownerOptions: { type: Object },
  },
  methods: {
    hereLink(path) {
      return '<a href="' + path + '">' + this.$t('global.here') + '</a>'
    },
  },
  computed: {
    hasOneOwnerOption() {
      if (Object.keys(this.ownerOptions).length > 1) {
        return false
      }

      return Object.keys(this.ownerOptions[Object.keys(this.ownerOptions)[0]]).length === 1
    },
    showFooter() {
      if (this.template === null) {
        return false
      }

      if (!this.ownerOptions || this.template) {
        return true
      }

      return !!this.owner
    },
  },
  mounted() {
    if (this.hasOneOwnerOption) {
      this.owner = Object.keys(this.ownerOptions[Object.keys(this.ownerOptions)[0]])[0]
    }
  },
}
</script>
